<template>
    <div class="blackout" v-if="data.active == 'rollback'" @click="data.active = false">

        <div class="popup big" @click.stop>
            <h1>Откатить статус парковки</h1>
            <div class="form-item checkbox _inline">
                <input type="checkbox" id="notify" v-model="notify_user" @change="changeNotify()" />
                <label for="notify">Оповестить пользователя</label>
            </div>
            <div v-if="notify_user">
                <div v-if="status == ''" class="popup-form">
                    <div class="form-item">
                        <label for="case">Кейс</label>
                        <select id="case" v-model="selected_case" @change="selectCase()">
                            <option v-for="(value, index) in cases" :key="index" :value="value.id.id">{{ value.title }}</option>
                        </select>
                    </div>

                    <div class="form-item inline" justify="center">
                        <div class="radio-item">
                            <input type="radio" id="langen" v-model="lang" value="en" />
                            <label for="langen">En</label>
                        </div>
                        <div class="radio-item">
                            <input type="radio" id="langes" v-model="lang" value="es" />
                            <label for="langes">Es</label>
                        </div>
                    </div>

                    <div v-if="caseOne.id && case_status != 'loading'" class="form-item">
                        <div class="form-item">
                            <label for="caseSubject">Заголовок</label>
                            <select v-if="caseOne.parts.subject.length" id="caseSubject" v-model="case_subject">
                                <option v-for="(value, index) in caseOne.parts.subject" :key="index" :value="value.id">{{ value.content[lang] }}</option>
                            </select>
                            <p v-else>Заголовки не найдены</p>
                        </div>
                        <div class="form-item">
                            <label>Тело сообщения</label>

                            <!--<div v-if="caseOne.parts.body.length" class="sortable" v-sortable="{ handle: '.handle' }" ref="sortable">
                                <div class="sortable-item checkbox" v-for="(value, index) in caseOne.parts.body" :key="index" :data-id="value.id">
                                    <input type="checkbox" :id="'caseBody'+index" v-model="value.checked" />
                                    <label :for="'caseBody'+index">
                                        <div class="sortable-lang">
                                            <p>{{ value.content[lang] }} {{ value.id }}</p>
                                        </div>
                                    </label>

                                    <i class="handle"></i>
                                </div>
                            </div>-->

                            <draggable v-if="sortableAr.length" class="sortable" v-model="sortableAr" group="cases">
                                <div class="sortable-item checkbox" v-for="(value, index) in sortableAr" :key="index" :data-id="value.id">
                                    <input type="checkbox" :id="'caseBody'+index" v-model="value.checked" />
                                    <label :for="'caseBody'+index">
                                        <div class="sortable-lang">
                                            <p>{{ value.content[lang] }} {{ value.id }}</p>
                                        </div>
                                    </label>

                                    <i class="handle"></i>
                                </div>
                            </draggable>


                            <p v-else>Сообщения не найдены</p>
                        </div>
                    </div>
                </div>
                <div class="page-load" v-show="status == 'loading' || case_status == 'loading'">
                    <div class="inline" valign="center">
                        <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                    </div>
                </div>
            </div>



            <div class="inline">
                <div class="button _free _decline" @click="data.active = false">Закрыть</div>
                <div class="button _free _accept" @click="rollback()">Откатить</div>
            </div>
        </div>
    </div>
</template>

<script>
    /*import Vue from 'vue'
    import Sortable from 'sortablejs'

    Vue.directive('sortable', {
        inserted: function (el, binding) {
            new Sortable(el, binding.value || {})
        }
    })*/
    import draggable from 'vuedraggable'

    export default {
        props: ['data'],
        components: {
            draggable,
        },
        data () {
            return {
                sortableAr: [],
                lang: 'es',
                notify_user: false,
                loaded_data: false,
                cases: {},
                caseOne: {},
                selected_case: false,
                status: '',
                case_status: '',
                case_subject: false,
                case_body: {}
            }
        },
        methods: {
            selectCase () {
                this.getOneCase()
            },
            changeNotify () {
                if (!this.loaded_data && this.notify_user) {
                    this.getCases()
                }
            },
            getOneCase () {

                this.caseOne = {}
                this.sortableAr = []
                this.case_subject = false

                this.case_status = 'loading'
                this.axios.get('api/admin/v2/email_case/' + this.selected_case)
                    .then(resp => {
                        this.caseOne = resp.data.response
                        if (this.caseOne.parts.subject.length) {
                            this.case_subject = this.caseOne.parts.subject[0].id
                        }
                        if (this.caseOne.parts.body.length) {
                            this.sortableAr = this.caseOne.parts.body
                        }
                        this.case_status = ''
                    })
                    .catch(() => {
                        this.case_status = ''
                    })
            },
            getCases () {
                this.status = 'loading'
                this.axios.get('api/admin/v2/email_case')
                    .then(resp => {
                        this.cases = resp.data.response.data
                        this.loaded_data = true


                        if (this.cases.length) {
                            switch (this.$route.name) {
                                case 'parking_one_common': this.selected_case = 4; break
                                case 'booking_request_one_contacts': this.selected_case = 6; break
                                case 'authorization_one': this.selected_case = 5; break
                                default: this.selected_case = this.cases[0].id.id
                            }

                            this.getOneCase()
                        }

                        this.status = ''
                    })
                    .catch(() => {
                        this.status = ''
                    })
            },
            getBody () {
                let result = []
                for (let item of this.sortableAr) {
                    if (item.checked) {
                        result.push(item.id)
                    }
                }
                return result
            },
            rollback () {
                let send_data = {}
                if (this.notify_user) {
                    send_data.email_case = {
                        "id": this.selected_case,
                        "subject": this.case_subject,
                        "body": this.getBody(),
                        "lang": this.lang
                    }
                }
                let json = JSON.stringify(send_data)
                this.axios.post('api/admin/v2/parking/' + this.data.content + '/rollback', json, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(result => {
                    this.data.active = false
                    let msg = ''
                    if (result.data.errors) {
                        msg = {
                            message: result.data.errors[0][1],
                            status: 'error'
                        }
                    } else {
                        msg = {
                            message: 'Откат выполнен',
                            status: 'success'
                        }
                        this.$emit('rollbackSuccess')
                    }
                    this.$store.dispatch('utils/showMessage', msg)
                }).catch(() => {
                    let msg = {
                        message: 'Ошибка при выполнении отката',
                        status: 'error'
                    }
                    this.$store.dispatch('utils/showMessage', msg)
                })
            }
        }
    }
</script>